import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import useMakeRequest from '../utils/ApiHelper';
import { ApiTypes } from '../constants/Constants';
import { ApiConstants } from '../constants/ApiConstants';
import FrontLoader from '../component/layout/FrontLoader';
import contactUsValidation from '../Validation/ContactUsValidation';
import { useSelector } from 'react-redux';
import { LanguageConstants } from '../constants/LanguageConstants';
import { socket } from '../utils/Socket';


interface FormInputs {
    name: string;
    email: string;
    subject:string;
    description:string;
    user_type:number
  };
function ContactusModal(props:any) {
    const contactAdd = useMakeRequest()
  const profiledata = useSelector((state:any)=>state?.ProfileState)


    const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
        mode: 'onChange',
        defaultValues:{
            user_type:1,
            subject:"test"
        },
        resolver: yupResolver(contactUsValidation),
      });
      const onSubmit = (payload: FormInputs) => {
        contactAdd.makeRequest({ payload, type:ApiTypes.POST, url: ApiConstants?.AddContactUs, toastStatus: true })
     }

    useEffect(()=>{
   if(contactAdd?.status){
       const socketpayload = {
                    sender_type: "1",
                    receiver_id: '1'
                }
                socket.emit('admin_count', socketpayload, async (Response: any) => {
                })
    props.handelClso()
   }
    },[contactAdd?.status]) 
    useEffect(()=>{
      if(profiledata?.data?.data){
        setValue('name',profiledata?.data?.data?.name)
        setValue('email',profiledata?.data?.data?.email)
      }
    },[profiledata?.data?.data])
  return (
    <>
    {contactAdd.loading ? <FrontLoader/> : null}
     <div className="modal fade com-modal rqst-quote-modal show" id="contactUsModal" aria-labelledby="contactUsModalLabel" aria-hidden="true" style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content"> 
                        <div className="modal-header">
                            <h5 className="modal-title" id="contactUsModalLabel">{LanguageConstants?.Contact_Us}</h5>
                            <button type="button" onClick={()=>props.handelClso()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body pb-0 text-start">
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.NAME}</label>
                                <input type="text" className="form-control" placeholder={LanguageConstants?.ENTER_FULL_NAME} {...register('name')}/>
                            </div>
                            <ErrorMessage
                                errors={errors}
                                name="name"
                                render={({ message }) => <p className='text-error-new'>{message}</p>}
                            />
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.EMAIL_ID}</label>
                                <input type="email" className="form-control" placeholder={LanguageConstants?.ENTER_EMAIL_ID} {...register('email')}/>
                            </div>
                            <ErrorMessage
                                errors={errors}
                                name="email"
                                render={({ message }) => <p className='text-error-new'>{message}</p>}
                            />
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.MESSAGE}</label>
                                <textarea className="form-control h-auto resize-none" placeholder={LanguageConstants?.WRITE} {...register('description')}  rows={4}></textarea>
                            </div>
                            <ErrorMessage
                                errors={errors}
                                name="description"
                                render={({ message }) => <p className='text-error-new'>{message}</p>}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="round-btn m-0 w-100" >{LanguageConstants?.SEND}</button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
    </>
  )
}

export default ContactusModal